export default __webpack_public_path__ + "static/media/paid.db80052a.png";